import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import getDataById from "../../../hooks/admin/getDataById";
import ApiLoadingSpinner from "../../../components/utils/ApiLoadingSpinner";
import ImageUploading from "react-images-uploading";
import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  Typography,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const AdminEditPlan = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [images, setImages] = useState([]);
  const [initialValues, setInitialValues] = useState({});

  const user = JSON.parse(localStorage.getItem("admin"));
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const getSinglePlan = async () => {
      const response = await getDataById("admin/getbyidplan", id);
      if (response.status_code === 200) {
        const data = response.data;
        setInitialValues(data);
        form.setFieldsValue(data);
      }
    };
    getSinglePlan();
  }, [id, form]);

  const onChange = (imageList) => {
    setImages(imageList);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const planInfo = new FormData();
    if (images[0]?.file) {
      planInfo.append("plan_logo", images[0]?.file);
    }

    for (const key in values) {
      planInfo.append(key, values[key]);
    }
    planInfo.append("id", id);

    const res = await fetch(`${process.env.REACT_APP_APIURL}/admin/updateplan`, {
      method: "PATCH",
      body: planInfo,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });

    const response = await res.json();
    if (response?.status_code === 200) {
      toast.success("Plan updated successfully");
      navigate("/admin/plan/all-plans");
    } else {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  if (loading) return <ApiLoadingSpinner />;

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-4">
        <Title level={3}>Edit Plan</Title>
        <Link to="/admin/plan/all-plans">
          <button  className="btn btn-primary btn-sm text-white"  >
         <span className="mr-2"><FaArrowCircleLeft /></span>   Go Back
          </button>
        </Link>
      </div>

      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Form.Item
            label="Plan Name"
            name="plan_name"
            rules={[{ required: true, message: "Please enter plan name" }]}
          >
            <Input placeholder="Plan Name" />
          </Form.Item>

          <Form.Item label="Plan Logo">
            <ImageUploading value={images} onChange={onChange} dataURLKey="data_url">
              {({ imageList, onImageUpload, onImageRemove }) => (
                <div>
                  <Button onClick={onImageUpload} icon={<UploadOutlined />}>
                    Upload Logo
                  </Button>
                  <div className="flex gap-2 mt-2">
                    {imageList.map((image, index) => (
                      <div key={index} className="relative">
                        <img src={image.data_url} alt="" className="w-20 h-20 object-cover" />
                        <Button danger size="small" onClick={() => onImageRemove(index)}>
                          Remove
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </ImageUploading>
          </Form.Item>

          <Form.Item
            label="Description"
            name="plan_description"
            rules={[{ required: true, message: "Please enter plan description" }]}
          >
            <Input placeholder="Description" />
          </Form.Item>

          <Form.Item
            label="Plan Price"
            name="plan_price"
            rules={[{ required: true, message: "Please enter price" }]}
          >
            <InputNumber style={{ width: "100%" }} placeholder="Price" />
          </Form.Item>

          <Form.Item
            label="Product Limit"
            name="product_limit"
            rules={[{ required: true, message: "Please enter product limit" }]}
          >
            <InputNumber style={{ width: "100%" }} placeholder="Product Limit" />
          </Form.Item>

          <Form.Item
            label="Storage Limit"
            name="storage_limit"
            rules={[{ required: true, message: "Please enter storage limit" }]}
          >
            <InputNumber style={{ width: "100%" }} placeholder="Storage Limit" />
          </Form.Item>

          <Form.Item
            label="Customer Limit"
            name="customer_limit"
            rules={[{ required: true, message: "Please enter customer limit" }]}
          >
            <InputNumber style={{ width: "100%" }} placeholder="Customer Limit" />
          </Form.Item>

          <Form.Item
            label="Number of Days"
            name="no_of_days"
            rules={[{ required: true, message: "Please enter validity days" }]}
          >
            <InputNumber style={{ width: "100%" }} placeholder="Validity in Days" />
          </Form.Item>

          <Form.Item>
            <button type="submmit" className="btn btn-primary text-white">
              Update
            </button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AdminEditPlan;